import { render, staticRenderFns } from "./BrandRecommend.vue?vue&type=template&id=d32f941a&scoped=true"
import script from "./BrandRecommend.vue?vue&type=script&lang=js"
export * from "./BrandRecommend.vue?vue&type=script&lang=js"
import style0 from "./BrandRecommend.vue?vue&type=style&index=0&id=d32f941a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32f941a",
  null
  
)

export default component.exports